import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "@/store"; // 添加store导入

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },

  {
    path: "/upload",
    name: "upload",
    component: () => import("@/views/upload.vue"),
    meta: {
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 在路由导航守卫中临时隐藏滚动条
router.beforeEach((to, from, next) => {
  document.body.style.overflow = "hidden"; // 隐藏滚动条
  window.scrollTo(0, 0);

  // 记录路由历史，使用命名空间
  store.dispatch("history/recordRoute", to);

  next();
});

router.afterEach(() => {
  document.body.style.overflow = ""; // 恢复滚动条
});
export default router;
